import React from "react";
import "../../styles/skeleton-loader.css";

const ProductSkeleton = () => {
  return (
    <div className="luxury-product-skeleton">
      <div className="skeleton-image skeleton-shimmer"></div>
      <div className="skeleton-content">
        <div className="skeleton-badge skeleton-shimmer"></div>
        <div className="skeleton-title skeleton-shimmer"></div>
        <div className="skeleton-title-short skeleton-shimmer"></div>
        <div className="skeleton-price skeleton-shimmer"></div>
        <div className="skeleton-rating">
          <div className="skeleton-star skeleton-shimmer"></div>
          <div className="skeleton-star skeleton-shimmer"></div>
          <div className="skeleton-star skeleton-shimmer"></div>
          <div className="skeleton-star skeleton-shimmer"></div>
          <div className="skeleton-star skeleton-shimmer"></div>
        </div>
        <div className="skeleton-button skeleton-shimmer"></div>
      </div>
    </div>
  );
};

export const ProductSkeletonGrid = ({ count = 6 }) => {
  return (
    <div className="product-grid">
      {Array.from({ length: count }).map((_, index) => (
        <ProductSkeleton key={index} />
      ))}
    </div>
  );
};

export default ProductSkeleton;
